import { render, staticRenderFns } from "./AlertPage.vue?vue&type=template&id=406ba916&scoped=true"
import script from "./AlertPage.vue?vue&type=script&lang=js"
export * from "./AlertPage.vue?vue&type=script&lang=js"
import style0 from "./AlertPage.vue?vue&type=style&index=0&id=406ba916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ba916",
  null
  
)

export default component.exports